import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
	isError: boolean = false;
	severity:Severity=Severity.info;
	messageId: string = "";

	constructor() { }

	set(messageId: string) {
	  this.messageId= messageId;
	  if( messageId.toLowerCase().startsWith( "info") )
	  {
		this.severity = Severity.info;
	  }
	  if( messageId.toLowerCase().startsWith( "error") )
	  {
		this.severity = Severity.error;
	  }
	  else if( messageId.toLowerCase().startsWith( "warn") )
	  {
		this.severity = Severity.warn;
	  }
	  else if( messageId.toLowerCase().startsWith( "success") )
	  {
		this.severity = Severity.success;
	  }
	  else if( messageId.toLowerCase().startsWith( "custom") )
	  {
		this.severity = Severity.custom;
	  }
	  else
	  {
		this.severity = Severity.info;
	  }
	}
  
	public get message():string
	{
		return this.messageId;
	}

	clear() {
	  this.messageId = "";
	}
}

export enum Severity {
	error = "error"
  , warn = "warn"
  , info = "info"
  , success = "success"
  , custom = "custom"
}
